/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PreviewMaterialItemViewDto = {
  type: PreviewMaterialItemViewDto.type;
  format?: PreviewMaterialItemViewDto.format;
  /**
   * URL — 영상 또는 파일(PDF/IMAGE) S3 URL
   */
  url: string;
  /**
   * 원본 파일명 (PDF/IMAGE 표시용)
   */
  fileName?: string;
  /**
   * 썸네일 URL
   */
  thumbnailUrl?: string;
  /**
   * 영상 길이(초)
   */
  durationSeconds?: number;
};
export namespace PreviewMaterialItemViewDto {
  export enum type {
    YOUTUBE = "YOUTUBE",
    PDF = "PDF",
    IMAGE = "IMAGE",
  }
  export enum format {
    LONGFORM = "LONGFORM",
    SHORTFORM = "SHORTFORM",
  }
}
